module.exports = __webpack_public_path__ + "img/lasource-4.f046e5d7.jpg";